export default "__VITE_ASSET__BeVus53t__"